<template>
    <div class="user-sign">
        <el-dialog
            title="中医药知识服务平台账号注册"
            :visible.sync="show"
            width="700px"
             :before-close="handleClose"
            center>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="登录名" prop="loginName">
                    <el-input placeholder="请输入登录名" v-model="ruleForm.loginName"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input placeholder="请输入密码" v-model="ruleForm.password" show-password></el-input>
                </el-form-item>
                 <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input placeholder="请再次输入密码" v-model="ruleForm.confirmPassword" show-password></el-input>
                </el-form-item>
                <el-form-item label="真实姓名" prop="name">
                    <el-input placeholder="请输入真实姓名" v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="单位" prop="unitTit">
                    <el-input placeholder="请输入单位名称" v-model="ruleForm.unitTit"></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                    <el-input placeholder="请输入电子邮箱" v-model="ruleForm.email"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input placeholder="请输入手机号码" v-model="ruleForm.phone"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="sure">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>  
export default {
    props: ['show'],
    data () {
        let validateInputSpecialKey = (rule, value, callback) => {
            var regex = /^[\u4e00-\u9fa5\d]+$/; // 定义正则表达式
            if (!regex.test(value)) {
                callback(new Error("只能输入字母和数字！"));
            } else {
                callback();
            }
        };
        let checkPhone = (rule, value, callback) => {
            let phoneReg = /^1[3456789]\d{9}$/; // 中国大陆的手机号正则表达式
            if (!value) {
                return callback(new Error('手机号不能为空'));
            } else if (!phoneReg.test(value)) {
                callback(new Error('请输入有效的手机号'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                loginName: '',
                password:'',
                confirmPassword:'',
                name:'',
                unitTit:'',
                email:'',
                phone:'',
            },
            rules: {
                loginName: [
                    { required: true, message: '请输入登录名', trigger: 'blur' },
                    { min: 6, max: 20, message: '登录名不能小于6个字符或大于20字符，登录名在6-20位并且仅能使用字母和数字！', trigger: 'blur' },
                    { validator: validateInputSpecialKey, trigger: "blur" }
                ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { validator: this.validatePassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { validator: this.validateConfirmPassword, trigger: 'blur' }
                ],
                // name:[
                //    { required: true, message: '请输入真实姓名', trigger: 'blur' },
                // ],
                // unitTit:[
                //    { required: true, message: '请输入真实姓名', trigger: 'blur' },
                // ],
                // email:[
                //     { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                //     { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                // ],
                phone:[
                    {required: true,  message: '请输入手机号码', trigger: 'blur' },
                    {validator:  checkPhone,trigger: 'blur' }
                ],
            }
        }
    },
    mounted () {
        
    },
    methods: {
        validatePassword(rule, value, callback) {
            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
            if (regex.test(value)) {
                callback();
            } else {
                callback(new Error('密码必须包含至少一个小写字母、一个大写字母、一个数字、一个特殊字符，长度至少为8个字符'));
            }
        },
        validateConfirmPassword(rule, value, callback) {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        },
        sure(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    alert('提交成功!');
                    this.handleClose();
                } else {
                    alert('表单校验失败!');
                    return false;
                }
            });
        },
        handleClose() {
            this.$emit('update:show',false)
            // this.$emit('cancel');
        },
    }

}
</script>

<style>

</style>